import { type ProfileImageCropperReducerState } from '../types.js';
import * as actionTypes from './actionTypes.js';
import { type ProfileImageCropperReducerActions } from './actionTypes.js';

export const initialState: ProfileImageCropperReducerState = {
  context: actionTypes.CONTEXT_TYPE_AVATAR,
  cropIsProcessing: false,
  croppedAreaPixels: {
    [actionTypes.CONTEXT_TYPE_AVATAR]: null,
    [actionTypes.CONTEXT_TYPE_BRAND_CUSTOMIZATION_LOGO]: null,
    [actionTypes.CONTEXT_TYPE_CONTACT]: null,
    [actionTypes.CONTEXT_TYPE_LOGO]: null,
  },
  croppedPreview: {
    [actionTypes.CONTEXT_TYPE_AVATAR]: null,
    [actionTypes.CONTEXT_TYPE_BRAND_CUSTOMIZATION_LOGO]: null,
    [actionTypes.CONTEXT_TYPE_CONTACT]: null,
    [actionTypes.CONTEXT_TYPE_LOGO]: null,
  },
  imageDataURL: null,
  imageFile: null,
  imageName: null,
  imageType: null,
  isCropping: false,
  isLoading: false,
  originalImageSize: {
    [actionTypes.CONTEXT_TYPE_AVATAR]: null,
    [actionTypes.CONTEXT_TYPE_BRAND_CUSTOMIZATION_LOGO]: null,
    [actionTypes.CONTEXT_TYPE_CONTACT]: null,
    [actionTypes.CONTEXT_TYPE_LOGO]: null,
  },
  saveProfileOnUpload: false,
  uploadImage: {
    [actionTypes.CONTEXT_TYPE_AVATAR]: null,
    [actionTypes.CONTEXT_TYPE_BRAND_CUSTOMIZATION_LOGO]: null,
    [actionTypes.CONTEXT_TYPE_CONTACT]: null,
    [actionTypes.CONTEXT_TYPE_LOGO]: null,
  },
};

export type ProfileImageCropperReducer = (
  state: ProfileImageCropperReducerState,
  action: ProfileImageCropperReducerActions,
) => ProfileImageCropperReducerState;

export const ProfileImageCropperReducer = (
  state: ProfileImageCropperReducerState,
  action: ProfileImageCropperReducerActions,
): ProfileImageCropperReducerState => {
  switch (action.type) {
    case actionTypes.RESET_CROPPING_STATE:
      return {
        ...initialState,
      };

    case actionTypes.START_CROPPING:
      return {
        ...state,
        imageDataURL: action.payload.imageDataURL,
        imageFile: action.payload.imageFile,
        imageName: action.payload.imageName,
        imageType: action.payload.imageType,
        isCropping: true,
      };

    case actionTypes.STOP_CROPPING:
      return {
        ...state,
        cropIsProcessing: false,
        isCropping: false,
        isLoading: false,
        saveProfileOnUpload: false,
      };

    case actionTypes.UPDATE_CONTEXT_PARAMETERS:
      return {
        ...state,
        context: action.payload.context,
        saveProfileOnUpload: action.payload.saveProfileOnUpload,
      };

    case actionTypes.UPDATE_CROPPED_PIXELS:
      return {
        ...state,
        croppedAreaPixels: {
          ...state.croppedAreaPixels,
          [state.context]: action.payload,
        },
      };

    case actionTypes.UPDATE_CROPPED_PREVIEW:
      return {
        ...state,
        croppedPreview: {
          ...state.croppedPreview,
          [state.context]: action.payload,
        },
      };
    case actionTypes.UPDATE_IS_MUTATION_IN_FLIGHT:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actionTypes.UPDATE_ORIGINAL_IMAGE_SIZE:
      return {
        ...state,
        originalImageSize: {
          ...state.originalImageSize,
          [state.context]: action.payload,
        },
      };

    case actionTypes.UPDATE_PROCESSING_STATE:
      return {
        ...state,
        cropIsProcessing: action.payload,
      };

    case actionTypes.UPDATE_UPLOAD_IMAGE:
      return {
        ...state,
        uploadImage: {
          ...state.uploadImage,
          [state.context]: action.payload,
        },
      };

    default:
      throw new Error('Requires a valid action');
  }
};
